import TagFacesOutlinedIcon from "@mui/icons-material/TagFacesOutlined";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import { withStyles } from "@mui/styles";
import * as React from "react";

const WhiteTextField = withStyles({
  root: {
    "& .MuiInputBase-input": {
      color: "#fff",
      fontSize: "14px",
    },
  },
})(InputBase);

interface chartInputProps {
  CommetAc: (deep: number, start: number, data: string) => void | undefined;
  hide: () => void;
  deep: number;
  index: number;
}

const ChartInput: React.FC<chartInputProps> = ({ CommetAc, hide, deep, index }) => {

  const AddCommet = (e: any): void => {
    CommetAc((deep + 1), index, e.target.value);
  }

  const keyPress = (e: any): void => {
    if (e.keyCode === 13) {
      AddCommet(e);
      hide();
    }
  }

  return (
    <Box
      sx={{
        p: "2px 4px",
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
        paddingRight: "12px",
        backgroundColor: "rgba(150,143,206,0.12156862745098039 )",
        borderRadius: "10px",
        boxShadow: "unset",
      }}
    >
      <WhiteTextField
        sx={{ ml: 1, flex: 1, color: "#ffffff", fontSize: "14px" }}
        onKeyDown={keyPress}
        placeholder="Add a comment..."
        inputProps={{ "aria-label": "Add a comment..." }}
      />
      <IconButton
        sx={{ color: "#c1c1c1", paddingRight: "0px", paddingY: "5px" }}
        aria-label="comment"
      >
        <TagFacesOutlinedIcon />
      </IconButton>
    </Box>
  );
};

export default ChartInput;
